"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.cronIntervals.every_5_minutes': 'Cada 5 minutos',
    'webhook.cronIntervals.every_10_minutes': 'Cada 10 minutos',
    'webhook.cronIntervals.every_15_minutes': 'Cada 15 minutos',
    'webhook.cronIntervals.every_30_minutes': 'Cada 30 minutos',
    'webhook.cronIntervals.every_45_minutes': 'Cada 45 minutos',
    'webhook.cronIntervals.every_hour': 'Cada hora',
    'webhook.cronIntervals.every_2_hours': 'Cada 2 horas',
    'webhook.cronIntervals.every_6_hours': 'Cada 6 horas',
    'webhook.cronIntervals.every_12_hours': 'Cada 12 horas',
    'webhook.cronIntervals.daily': 'Diariamente (medianoche)',
    'webhook.cronIntervals.weekly': 'Semanalmente (domingo medianoche)',
};
